import { Queue } from '@datastructures-js/queue';

import { type Deferrable } from '@canvas/deferrable';

import { type BaseCommandProperties, type Command } from './command-definition.ts';

type CommandQueueItem<T extends BaseCommandProperties> = {
  command: Command<T>;
  deferrable: Deferrable<void>;
};
export class CommandQueue<T extends BaseCommandProperties> extends Queue<
  CommandQueueItem<T>
> {
  public forEachCommand(
    subscriberName: string,
    cb: (subscriberName: string, command: Command<T>) => void,
  ) {
    let item = this.dequeue();
    while (item != null) {
      cb(subscriberName, item.command);
      item.deferrable.resolve();
      item = this.dequeue();
    }
  }
}
